/** Define the Arachnet identity used throughout the private fleet dashboard. */
export const brand = {
  owner: "Arachnet Systems Limited",
  product: "Network operations",
  lockup: "/brand/arachnet-lockup.png",
  description: "Live health, resource pressure, backup readiness, and update posture across every enrolled system.",
} as const;
